import type { Fallacy } from "./types";
import { createStory } from "./types";

export const appealToNature: Fallacy = {
    id: "appeal-to-nature",
    name: "Appeal to Nature",
    emoji: "🌿",
    category: "Manipulasi Emosi & Sosial",
    description:
      "Berargumen bahwa sesuatu pasti baik karena '**alami**', atau buruk karena 'tidak alami'. **Alami ≠ otomatis baik**.",
    detail:
      "Appeal to Nature adalah kesalahan logika di mana seseorang berasumsi bahwa yang **'alami' pasti baik**, dan yang **'tidak alami' atau 'kimia' pasti buruk**.\n\nFakta yang sering dilupakan: arsenik, uranium, dan racun ular itu alami — tapi berbahaya. Sementara antibiotik dan vaksin itu 'buatan' — tapi menyelamatkan jutaan nyawa. **SEMUA zat di alam semesta adalah bahan kimia** — termasuk air (H2O) dan oksigen (O2).\n\nCara mengenali: Setiap kali argumen bergantung pada kata 'alami' sebagai jaminan kebaikan, atau 'kimia/buatan' sebagai bukti keburukan — itu Appeal to Nature.",
    tldr: "Alami belum tentu aman, kimia belum tentu bahaya. Racun ular juga alami, bro.",
    story: createStory("Appeal to Nature", "🌿", {
      hook: {
        title: "\"Ini kan alami, pasti aman!\"",
        body: "Yakin? Racun ular juga alami. Arsenik juga alami. **Alami bukan jaminan baik.**",
      },
      convo: {
        claim: "Obat kimia mah racun. **Mending jamu herbal, kan alami.** Yang alami pasti lebih aman!",
        response: "Alami bukan jaminan aman. Racun ular juga alami, **antibiotik 'buatan' justru selamatin jutaan nyawa.**",
      },
      reveal: {
        body: "Nganggep yang **alami pasti baik**, yang **kimia/buatan pasti buruk**. Padahal **semua zat di alam semesta itu bahan kimia** — termasuk air (H2O).",
      },
      insight: {
        title: "Faktanya?",
        body: "Antibiotik dan vaksin itu 'buatan' — tapi **menyelamatkan jutaan nyawa**. Sementara arsenik dan racun ular? 100% alami.",
      },
      engagement: {
        title: "Kamu tim \"alami pasti lebih sehat\" atau udah move on?",
        body: "MSG, obat dokter, sunscreen — mana yang masih kamu raguin? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["appeal-to-authority", "hasty-generalization", "appeal-to-emotion"],
  };
